var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center mt-4" };
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { saveLink } from '@/../../EshJSLib/services/linkPersonaleServices';
import altroLinkPersonali from "@/../../EshJSLib/models/form/altroLinkPersonali.json";
import altroOspedaliItaliani from "@/../../EshJSLib/models/form/altroOspedaliItaliani.json";
import altroOspedaliEsteri from "@/../../EshJSLib/models/form/altroOspedaliEsteri.json";
import altroLineeGuidaItaliane from "@/../../EshJSLib/models/form/altroLineeGuidaItaliane.json";
import altroLineeGuidaInternazionali from "@/../../EshJSLib/models/form/altroLineeGuidaInternazionali.json";
import altroRisorseWebItaliane from "@/../../EshJSLib/models/form/altroRisorseWebItaliane.json";
import altroRisorseWebInternazionali from "@/../../EshJSLib/models/form/altroRisorseWebInternazionali.json";
import altroRivisteItaliane from "@/../../EshJSLib/models/form/altroRivisteItaliane.json";
import altroRivisteInternazionali from "@/../../EshJSLib/models/form/altroRivisteInternazionali.json";
import { reactive, ref, onMounted } from "vue";
import linkPersonaliCreate from "./linkPersonaliCreate.vue";
import TableRow from './TableRow.vue';
import { getLineGuidaInternazionaleLinks, getOspedaliItalianiLinks, getLineGuidaItalianeLinks, getOspedaliEsteriLinks, getRisorveWebInternazionaleLinks, getRisorveWebItalianeLinks, getRivisteInternazionaliLinks, getRivisteItalianeLinks } from "../../../../EshJSLib/services/altroLinkServices";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
//Ref Element with HTML
export default /*#__PURE__*/ _defineComponent({
    __name: 'AltroPage',
    setup: function (__props) {
        var _this = this;
        var alertModal = ref(null);
        //const linkPersonaliCreate = ref<InstanceType<typeof linkPersonaliCreate> | null>(null);
        var isShownModal = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var isModalOpen = ref(false);
        var showLoading = ref(false);
        var router = useRouter();
        var data = reactive({
            altroRivisteInternazionaliLinks: [],
            altroRivisteItalianeLinks: [],
            altroRisorseWebInternazionaliLinks: [],
            altroRisorseWebItalianeLinks: [],
            altroLineGuidaInternazionaliLinks: [],
            altroLineGuidaItalianeLinks: [],
            altroOspedaliEsteriLinks: [],
            altroOspedaliItalianiLinks: [],
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        showLoading.value = true;
                        patient.value.links;
                        store.fetchLink();
                        _a = data;
                        return [4 /*yield*/, getRivisteInternazionaliLinks()];
                    case 1:
                        _a.altroRivisteInternazionaliLinks = _j.sent();
                        _b = data;
                        return [4 /*yield*/, getRivisteItalianeLinks()];
                    case 2:
                        _b.altroRivisteItalianeLinks = _j.sent();
                        _c = data;
                        return [4 /*yield*/, getRisorveWebInternazionaleLinks()];
                    case 3:
                        _c.altroRisorseWebInternazionaliLinks = _j.sent();
                        _d = data;
                        return [4 /*yield*/, getRisorveWebItalianeLinks()];
                    case 4:
                        _d.altroRisorseWebItalianeLinks = _j.sent();
                        _e = data;
                        return [4 /*yield*/, getLineGuidaInternazionaleLinks()];
                    case 5:
                        _e.altroLineGuidaInternazionaliLinks = _j.sent();
                        _f = data;
                        return [4 /*yield*/, getLineGuidaItalianeLinks()];
                    case 6:
                        _f.altroLineGuidaItalianeLinks = _j.sent();
                        _g = data;
                        return [4 /*yield*/, getOspedaliEsteriLinks()];
                    case 7:
                        _g.altroOspedaliEsteriLinks = _j.sent();
                        _h = data;
                        return [4 /*yield*/, getOspedaliItalianiLinks()];
                    case 8:
                        _h.altroOspedaliItalianiLinks = _j.sent();
                        setTimeout(function () {
                            showLoading.value = false;
                        }, 3000);
                        return [2 /*return*/];
                }
            });
        }); });
        var indexgl = ref(null);
        var newlink = reactive({});
        function saveAndRefreshLink(userInput, row) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (userInput) {
                        showLoading.value = true;
                        saveLink(row).then(function (x) {
                            store.fetchLink();
                            showLoading.value = false;
                        }).catch(function (error) {
                            showLoading.value = false;
                            alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
                        });
                    }
                    else {
                        store.fetchLink();
                    }
                    return [2 /*return*/];
                });
            });
        }
        function movePage() {
            router.push({ path: '/registro/Paypal' });
        }
        function addLinkPersonali() {
            newlink = reactive({});
            // indexgl.value = patient.value.links.length;
            // patient.value.links = patient.value.links.concat(reactive(newlink as unknown as Link));
            isModalOpen.value = true;
        }
        function closeModal() {
            // store.refreshScheda(store.patient.id_paziente);
            isModalOpen.value = false;
            //  store.fetchLink()
        }
        function action(type, row, index, table) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            userInput = false;
                            _b = type;
                            switch (_b) {
                                case "add": return [3 /*break*/, 1];
                                case 'trash': return [3 /*break*/, 3];
                                case "pen": return [3 /*break*/, 4];
                                case 'eye': return [3 /*break*/, 9];
                            }
                            return [3 /*break*/, 10];
                        case 1: return [4 /*yield*/, hasPermission('aggiungialtro')];
                        case 2:
                            // row = {} as Link
                            // row.id_link = 0
                            // row.id_paziente = patient.value.id_paziente
                            // row.status = 'add'
                            //userInput = await linkPersonaliCreate.value?.openModal("Crea Link Personale", row);
                            //saveAndRefreshLink(userInput, row)
                            if (_c.sent()) {
                                addLinkPersonali();
                            }
                            else {
                                isShownModal.alert = true;
                            }
                            return [3 /*break*/, 10];
                        case 3:
                            alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then(function (userInput) {
                                row.status = 'delete';
                                saveAndRefreshLink(userInput, row);
                            });
                            return [3 /*break*/, 10];
                        case 4: return [4 /*yield*/, hasPermission('modificaaltro')];
                        case 5:
                            if (!_c.sent()) return [3 /*break*/, 7];
                            row.status = 'update';
                            return [4 /*yield*/, ((_a = linkPersonaliCreate.value) === null || _a === void 0 ? void 0 : _a.openModal("Modifica Link", row))];
                        case 6:
                            userInput = _c.sent();
                            saveAndRefreshLink(userInput, row);
                            return [3 /*break*/, 8];
                        case 7:
                            isShownModal.alert = true;
                            _c.label = 8;
                        case 8: return [3 /*break*/, 10];
                        case 9:
                            window.open(row.link);
                            return [3 /*break*/, 10];
                        case 10: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(CollapsibleItem, {
                        data: _unref(altroLinkPersonali),
                        onRowActions: _cache[0] || (_cache[0] = function (n, r, i) { return action(n, r, i, 'links'); }),
                        onCreateForm: _cache[1] || (_cache[1] = function ($event) { return (action('add', null, 0, '0')); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroOspedaliItaliani) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroOspedaliItalianiLinks,
                                showTableHeads: true
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroOspedaliEsteri) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroOspedaliEsteriLinks,
                                showTableHeads: true
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroLineeGuidaItaliane) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroLineGuidaItalianeLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroLineeGuidaInternazionali) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroLineGuidaInternazionaliLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroRisorseWebItaliane) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroRisorseWebItalianeLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroRisorseWebInternazionali) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroRisorseWebInternazionaliLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroRivisteItaliane) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroRivisteItalianeLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(altroRivisteInternazionali) }, {
                        default: _withCtx(function () { return [
                            _createVNode(TableRow, {
                                data: data.altroRivisteInternazionaliLinks
                            }, null, 8, ["data"])
                        ]; }),
                        _: 1
                    }, 8, ["data"]),
                    (_unref(isModalOpen) == true)
                        ? (_openBlock(), _createBlock(linkPersonaliCreate, {
                            key: 0,
                            onCancel: closeModal
                        }))
                        : _createCommentVNode("", true),
                    (showLoading.value)
                        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 1 }))
                        : _createCommentVNode("", true),
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    (isShownModal.alert)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 2,
                            onClose: _cache[4] || (_cache[4] = function ($event) { return (isShownModal.alert = false); })
                        }, {
                            body: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("button", {
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (isShownModal.alert = false); }),
                                        type: "button",
                                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                    }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (movePage()); }),
                                        type: "button",
                                        class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                    }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                                ])
                            ]; }),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
